import { toast } from "react-toastify";
import { takeEvery, call, put } from "redux-saga/effects";

import {
  setCreatedInvoiceid,
  setInvoiceCanCreate,
  setInvoiceRecord,
  setInvoiceRecordById,
  setNonInvoicedBooking,
} from "../../redux/app/invoiceRecord/invoiceRecord-slice";
import {
  checkTokenExistAction,
  createInvoiceRecordAction,
  deleteInvoiceRecordAction,
  getAllInvoiceRecordAction,
  getInvoiceRecordByIdAction,
  getNonInvoicedBookingAction,
  updateInvoiceRecordAction,
} from "../../api/docketActions/InvoiceRecord-action";

function* createInvoiceRecordSaga(action) {
  try {
    const reponse = yield call(createInvoiceRecordAction, action.payload);

    if (reponse.status === 201) {
      toast.success("Create invoice record successfully");
      // action.payload.navigate(`/invoice/${response?.}`)
      yield put(
        setCreatedInvoiceid({ createdInvoiceid: reponse.data.invoiceNumber })
      );
    }
  } catch (error) {
    toast.error(error.message);
  }
}

function* getNonInvoicedBookingSaga(action) {
  try {
    const reponse = yield call(getNonInvoicedBookingAction, action.payload);

    if (reponse.status === 200) {
      yield put(setNonInvoicedBooking({ nonInvoicedBooking: reponse.data }));
    }
  } catch (error) {}
}

function* checkTokenExistSaga(action) {
  try {
    toast.loading("Checking...");
    const reponse = yield call(checkTokenExistAction, action.payload);

    if (reponse.status === 200) {
      toast.dismiss();
      if (reponse.data.msg === "Invoice Number Exists") {
        toast.error(`${reponse.data.msg}`);
      } else {
        toast.success(`${reponse.data.msg}`);
        yield put(setInvoiceCanCreate({ invoiceCanCreate: true }));
      }
    }
  } catch (error) {
    toast.dismiss();

    toast.error(error?.reponse?.data?.msg);
  }
}

function* getAllInvoiceRecordSaga(action) {
  try {
    const reponse = yield call(getAllInvoiceRecordAction, action.payload);

    if (reponse.status === 200) {
      yield put(setInvoiceRecord({ invoiceRecord: reponse.data }));
    }
  } catch (error) {
    toast.error(error.message);
  }
}

function* getInvoiceRecordByIdSaga(action) {
  try {
    const reponse = yield call(getInvoiceRecordByIdAction, action.payload);

    if (reponse.status === 200) {
      yield put(setInvoiceRecordById({ invoiceRecordById: reponse.data }));
    }
  } catch (error) {
    toast.error(error.message);
  }
}

function* updateInvoiceRecordSaga(action) {
  try {
    toast.loading("Saving...");
    const reponse = yield call(updateInvoiceRecordAction, action.payload);

    if (reponse.status === 200) {
      toast.dismiss();
      toast.success("Update invoice record successfully");
    }
  } catch (error) {
    toast.error(error.message);
  }
}

function* deleteInvoiceRecordSaga(action) {
  try {
    const reponse = yield call(deleteInvoiceRecordAction, action.payload);

    if (reponse.status === 200) {
      toast.success("Delete invoice record successfully");
      yield put({
        type: "GET_ALL_INVOICE_RECORDS",
        payload: { token: action.payload.token },
      });
    }
  } catch (error) {
    toast.error(error.message);
  }
}

export function* watchAsyncInvoiceRecord() {
  yield takeEvery("CREATE_INVOICE_RECORD", createInvoiceRecordSaga);
  yield takeEvery("GET_NON_INVOICED_BOOKING", getNonInvoicedBookingSaga);
  yield takeEvery("CHECK_INVOICE_NUM", checkTokenExistSaga);
  yield takeEvery("GET_ALL_INVOICE_RECORDS", getAllInvoiceRecordSaga);
  yield takeEvery("GET_INVOICE_RECORD_BY_ID", getInvoiceRecordByIdSaga);
  yield takeEvery("UPDATE_INVOICE_RECORD", updateInvoiceRecordSaga);
  yield takeEvery("DELETE_INVOICE_RECORD", deleteInvoiceRecordSaga);
}
